import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import Loading from "@/client/modules/retornos/loading";
import { RetornosClient } from "@/client/modules/retornos/retornos-client";

export const Route = createFileRoute("/app/retornos")({
  loader: ({ context }) => ensurePage(context.queryClient, apiQuery("retornos", "page", {})),
  head: () => pageHead("Retornos"),
  pendingComponent: Loading,
  component: RetornosPage,
});

function RetornosPage() {
  const { data } = useApiSuspenseQuery("retornos", "page", {});
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Retornos" description="Pacientes a chamar para voltar, organizados por mês." />
      <RetornosClient recalls={data.recalls} patients={data.patients} />
    </div>
  );
}
